import { MotionProps, motion } from 'framer-motion';

export const BasicFade: React.FC<MotionProps> = ({ children, ...rest }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ type: 'just' }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const SlideFadeIn: React.FC<MotionProps & { offset: number }> = ({
  children,
  offset,
  ...rest
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: offset }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0 }}
      transition={{ type: 'just' }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
